module.exports = __webpack_public_path__ + "img/spin.075dff37.webp";